import PersianSupportNumericTextField from "Global/Components/UnEditableComponents/PersianSupportNumericTextField/PersianSupportNumericTextField";
import PersianSupportTextField from "Global/Components/UnEditableComponents/PersianSupportTextField/PersianSupportTextField";
import styles from "../../../Login/Styles/Login.Normal.Forms.module.scss";
import React from "react";
import { Button } from "@mui/material";
import { useForm } from "react-hook-form";
import { variables } from "./Variables/DefaultValues";
import SingleReactHookFormWrapper from "Global/Components/Generators/SingleReactHookFormWrapper/SingleReactHookFormWrapper";
import { ResetPassword } from "../../Adapters/ResetPassword";
import { useContext } from "react";
import { GlobalContext } from "Global/Context/GlobalContextProvider";
import { useTranslation } from "react-i18next";
import FindLangKey from "Global/Functions/FindLangKey/FindLangKey";
import { themeColors } from "Global/JsxThemeColor/JsxThemeColor";

const ForgotPassword = () => {
  const { control, formState, handleSubmit } = useForm({
    defaultValues: variables,
  });
  const GlobalConstants = useContext(GlobalContext);
  const languageArray = useContext(GlobalContext)?.LanguageArray;
  const navigate = GlobalConstants.navigate;
  const PasswordRecovery = FindLangKey(
    "login-button-password-recovery",
    languageArray
  );
  const resetPasswordMsg = FindLangKey(
    "general-public-alert-success-operation"
  );
  const fillEmptyMsg = FindLangKey("sign-up-alert-fill-empty");
  return (
    <React.Fragment>
      <form
        onSubmit={handleSubmit((data) =>
          ResetPassword(
            data,
            navigate,
            languageArray,
            resetPasswordMsg,
            fillEmptyMsg
          )
        )}
      >
        <div className={styles.loginForms} dir="rtl">
          <SingleReactHookFormWrapper
            element={
              <PersianSupportTextField
                label={FindLangKey("login-input-user-name", languageArray)}
              />
            }
            control={control}
            errors={formState.errors}
            name="UserName"
            required={true}
          />
          <SingleReactHookFormWrapper
            element={
              <PersianSupportTextField
                label={FindLangKey(
                  "general-public-mobile-number",
                  languageArray
                )}
              />
            }
            control={control}
            errors={formState.errors}
            name="Mobile"
            required={true}
          />
          <Button
            fullWidth
            color="colorPrimer"
            variant="contained"
            type="submit"
            sx={{
              marginTop: "-0.3em",
              color: `${themeColors.ColorPrimary} !important`,
            }}
          >
            {PasswordRecovery}
          </Button>
        </div>
      </form>
    </React.Fragment>
  );
};

export default ForgotPassword;
